/* eslint-disable */
import { Reducer } from 'redux'
import { toast } from 'react-toastify'
import { call, put, takeLatest, all } from 'redux-saga/effects'
import { SagaAction, GetResponse } from 'src/@types'
import { API } from 'src/services/config'

interface ICoatState {
  pelagem: string
  descricao: string
}

export interface CoatState {
  loading: boolean
  list: Array<ICoatState>
}

const customModule = '@COAT'

const GET = {
  REQUEST: `${customModule}/GET_REQUEST`,
  SUCCESS: `${customModule}/GET_SUCCESS`,
  FAILED: `${customModule}/GET_FAILED`
}

const initialState: CoatState = {
  loading: false,
  list: []
}

export const coatReducer: Reducer<CoatState> = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET.REQUEST:
      return { ...state, isLoading: true }
    case GET.SUCCESS:
      return { ...state, list: payload, isLoading: false }
    case GET.FAILED:
      return { ...state, isLoading: false }
    default:
      return state
  }
}

export const getCoatList = () => ({ type: GET.REQUEST })

const ROUTE = '/entity/Pelagem'

// eslint-disable-next-line
function* get({ payload }: SagaAction<string>) {
  try {
    const { data }: GetResponse<any> = yield call(API.get, `${ROUTE}`)
    const dataOrdered = data.sort((a: any, b: any) => a.descricao.localeCompare(b.descricao))
    yield put({ type: GET.SUCCESS, payload: dataOrdered })
  } catch (error: any) {
    yield put({ type: GET.FAILED })
    const message = 'Erro ao buscar lista de pelagem.'
    toast.error(message)
    console.error(error)
  }
}

export const CoatSaga = all([takeLatest(GET.REQUEST, get)])
